import { render, staticRenderFns } from "./DetailModule.vue?vue&type=template&id=1496c800&scoped=true"
import script from "./DetailModule.vue?vue&type=script&lang=js"
export * from "./DetailModule.vue?vue&type=script&lang=js"
import style0 from "./DetailModule.vue?vue&type=style&index=0&id=1496c800&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1496c800",
  null
  
)

export default component.exports